import React from "react";
import { Link } from "react-router-dom";
import { formatARS } from "@/lib/api";
import useUiTexts, { uiText } from "@/lib/uiTexts";
import { collectionLabel } from "@/lib/collections";

export const ProductCard = ({ p, index = 0 }) => {
  const T = useUiTexts();
  const sold = p.available_total <= 0;
  return (
    <Link
      to={`/pieza-expediente/${p.id}`}
      data-testid={`product-card-${p.id}`}
      className="group block museum-frame hover-lift fade-up"
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <div className="img-zoom relative aspect-[3/4] bg-[#CFD1D6] overflow-hidden">
        {p.images?.[0] ? (
          <img src={p.images[0]} alt={p.name} className="w-full h-full object-cover" loading="lazy" />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-[#858A91] dossier-label">sin imagen</div>
        )}
        <div className="absolute top-3 left-3 flex gap-2">
          {p.vip && <span className="dossier-label bg-[#171719] text-[#F4F4F3] px-2 py-1">VIP</span>}
          {p.exhibition ? (<>
            <span className="dossier-label bg-black/70 text-[#F4F4F3] px-2 py-1 border border-[#2A2A2A]">pieza de archivo</span>
            <span data-testid={`badge-soon-${p.id}`} className="dossier-label bg-[#171719] text-[#F4F4F3] px-2 py-1 border border-[#171719]">{uiText(T, "card_badge")}</span>
          </>) : sold ? (
            <span className="dossier-label bg-black/70 text-[#E8E9EB] px-2 py-1 border border-[#2A2A2A]">agotó archivo</span>
          ) : (
            <span className="dossier-label bg-[#1C241D] text-[#4C7A51] px-2 py-1">libre</span>
          )}
        </div>
        {p.edition_total && (
          <div className="absolute bottom-3 right-3 dossier-label text-[#F4F4F3] bg-black/60 px-2 py-1">ed. {p.edition_total}</div>
        )}
      </div>
      <div className="p-4">
        <div className="dossier-label text-[#565A61] mb-1">{p.design_code} · {p.edition_name || "Expediente"}{p.collection ? ` · ${collectionLabel(p.collection)}` : ""}</div>
        <h3 className="font-display font-bold uppercase tracking-tight text-[#171719] text-lg leading-tight group-hover:text-[#56677A]">{p.name}</h3>
        <div className="mt-2 text-sm">
          {p.price != null ? (
            <span className="text-[#171719] font-medium">{formatARS(p.price)}</span>
          ) : p.exhibition ? (
            <span className="dossier-label text-[11px] text-[#565A61]">{uiText(T, "card_cta")}</span>
          ) : (
            <span className="text-[#565A61] italic">Consultar · pieza en desarrollo</span>
          )}
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
